/**
 * Artifact edit history service (DB-backed, Supabase via backend)
 */

import { apiJson } from "./apiClient";

export async function listArtifactEditHistory(artifactId, { limit = 50 } = {}) {
  const json = await apiJson(`/artifacts/${artifactId}/edit_history?limit=${limit}`, {
    method: "GET",
  });
  if (!json?.success) throw new Error(json?.error || "아티팩트 변경 이력 조회 실패");
  return json.history || [];
}

export async function createArtifactEditHistory(artifactId, payload) {
  const json = await apiJson(`/artifacts/${artifactId}/edit_history`, {
    method: "POST",
    body: JSON.stringify(payload || {}),
  });
  if (!json?.success) throw new Error(json?.error || "아티팩트 변경 이력 저장 실패");
  return json.history;
}
